import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useSession } from "@/api/session";
import { PageLoading } from "@/components/States";

/** Gates /app routes; remembers where the user was heading. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useSession();
  const location = useLocation();

  if (status === "loading") {
    return <PageLoading label="Checking your session…" />;
  }
  if (status === "anonymous") {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return <>{children}</>;
}
